import { createCrudThunks } from "./utils/thunk";
import { createCrudReducer } from "./utils/reducer";
import api from "./TipoEspaco/api";

const label = "Tipo de espaço";
const entidade = "tiposEspaco";

export const { get, add, update, deletar } = createCrudThunks(entidade, api, label);
const TipoEspacoReducer = createCrudReducer(entidade, { get, add, update, deletar });

export {
  get as getTiposEspaco,
  add as addNewTipoEspaco,
  update as updateTipoEspaco,
  deletar as deleteTipoEspaco,
};

export default TipoEspacoReducer;
